import { Action } from './action';

export class NetworkConnected extends Action {
}

export class NetworkDisconnected extends Action {
}
